<template>
  <b-row>
    <b-col cols="12">
      <b-form @submit.prevent>
        <b-form-group
          :label="isRenderingLabel ? 'انتخاب گروه بندی' : ''"
          label-for="language-picker"
        >
          <v-select
            :disabled="isDisabled"
            id="language-picker"
            dir="rtl"
            :filterable="false"
            v-if="priceCategoriesList"
            :reduce="(priceCategory) => priceCategory.id"
            v-model="selectedPriceCategory"
            :options="priceCategoriesList"
            label="title"
            :multiple="isMultiple"
            placeholder="گروه‌بندی را انتخاب کنید"
          >
            <template #no-options>هیچ گروه‌بندی جهت نمایش وجود ندارد</template>
          </v-select>
        </b-form-group>
      </b-form>
    </b-col>
  </b-row>
</template>
<script>
export default {
  emits: ["getPriceCategory"],
  props: {
    defaultPriceCategoryIds: {
      type: [Number, String, Array],
      required: false,
      default: null,
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    isMultiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    isRenderingLabel: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  watch: {
    selectedPriceCategory: {
      handler(val) {
        this.$emit("getPriceCategory", val);
      },
    },
    defaultPriceCategoryIds: {
      handler(val) {
        if (val && val != "" && val != 0) {
          this.getLitePriceCategories();
        }
      },
    },
  },
  mounted() {
    this.getLitePriceCategories();
  },
  data() {
    return {
      priceCategoriesList: null,
      selectedPriceCategory: null,
      searchVal: null,
      timeout: null,
    };
  },
  methods: {
    // handleSearch(searchValue, loadingFn) {
    //   if (this.timeout) {
    //     clearTimeout(this.timeout);
    //   }
    //   this.timeout = setTimeout(async () => {
    //     this.searchVal = searchValue;
    //     loadingFn(true);
    //     await this.getLitePriceCategories();
    //     loadingFn(false);
    //   }, 300);
    // },
    async getLitePriceCategories() {
      try {
        let qParams = {
          count: 30,
          pageNumber: 1,
        };
        // if (this.defaultCourseId) {
        //   qParams["courseId"] = this.defaultCourseId;
        // }
        // if (this.searchVal && this.searchVal != "") {
        //   qParams["searchCommand"] = this.searchVal;
        // }
        let _this = this;
        let getLitePriceCategories = new GetLitePriceCategories(_this);
        getLitePriceCategories.setRequestParam(qParams);
        await getLitePriceCategories.fetch((response) => {
          if (response) {
            _this.priceCategoriesList = response;
            if (_this.defaultPriceCategoryIds) {
              _this.selectedPriceCategory = _this.defaultPriceCategoryIds;
            }
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
  },
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    vSelect,
  },
};
import { BRow, BCol, BForm, BFormGroup } from "bootstrap-vue";
import vSelect from "vue-select";
import { GetLitePriceCategories } from "@/libs/Api/PriceCategory";
</script>
